const options = { year: 'numeric', month: 'long', day: 'numeric' }


export const formatLocaleDate = (date) => new Date(date).toLocaleDateString('de-DE', options)
